import { PropsWithChildren, createContext, useContext } from 'react';

import { HelpFormValues } from 'shared/components/dialogs';
import {
  useLeftMenuDrawer,
  useRedeemModal,
  useClaimModal,
  useMarkPost,
  useCreatePost,
  useEditPost,
  useAboutModal,
  useInviteModal,
  useCurrentDiscount,
  useModalState,
  useToast,
} from 'shared/hooks';

function useGlobalStateValues() {
  const toasts = useToast();
  const leftMenuDrawer = useLeftMenuDrawer();
  const redeemModal = useRedeemModal(false);
  const claimModal = useClaimModal(false);
  const markPost = useMarkPost(false);
  const createPost = useCreatePost(false);
  const editPost = useEditPost(false);
  const aboutModal = useAboutModal(false);
  const inviteModal = useInviteModal(false);
  const currentDiscount = useCurrentDiscount(null);
  const contentCurationBubble = useModalState({ show: true });
  const helpModal = useModalState<HelpFormValues>();

  return {
    toasts,
    leftMenuDrawer,
    redeemModal,
    claimModal,
    markPost,
    createPost,
    editPost,
    aboutModal,
    inviteModal,
    currentDiscount,
    contentCurationBubble,
    helpModal,
  };
}

type GlobalState = ReturnType<typeof useGlobalStateValues>;

const GlobalStateContext = createContext<GlobalState>({} as unknown as GlobalState);

export function GlobalStateProvider(props: PropsWithChildren<unknown>) {
  const values = useGlobalStateValues();

  return <GlobalStateContext.Provider value={values}>{props.children}</GlobalStateContext.Provider>;
}

export function useGlobalState() {
  return useContext(GlobalStateContext);
}
